import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";

const SmartSelect = ({ value, onValueChange, options, placeholder = "Select...", className = "", allowCustom = true, "data-testid": testId }) => {
  const [customMode, setCustomMode] = useState(false);
  const [customText, setCustomText] = useState("");

  const isCustom = customMode || (value && !options.some(o => o.value === value) && value !== "not_known");

  const handleSelect = (v) => {
    if (v === "__other__") {
      setCustomMode(true);
      setCustomText("");
      onValueChange("");
    } else {
      setCustomMode(false);
      setCustomText("");
      onValueChange(v);
    }
  };

  const handleCustomChange = (e) => {
    setCustomText(e.target.value);
    onValueChange(e.target.value);
  };

  const handleBackToSelect = () => {
    setCustomMode(false);
    setCustomText("");
    onValueChange("");
  };

  if (isCustom) {
    return (
      <div className="flex gap-1.5">
        <Input
          value={customText || value}
          onChange={handleCustomChange}
          placeholder="Type custom value..."
          className={`flex-1 ${className}`}
          data-testid={testId ? `${testId}-custom` : undefined}
          autoFocus
        />
        <button
          onClick={handleBackToSelect}
          className="px-2 text-xs text-slate-500 hover:text-slate-700 border rounded-md hover:bg-slate-50 transition-colors shrink-0"
          type="button"
        >
          List
        </button>
      </div>
    );
  }

  return (
    <Select value={value} onValueChange={handleSelect}>
      <SelectTrigger className={className} data-testid={testId}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map(opt => (
          <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
        ))}
        <SelectItem value="not_known">Not Known</SelectItem>
        {allowCustom && <SelectItem value="__other__">Other (custom)</SelectItem>}
      </SelectContent>
    </Select>
  );
};

export const CASE_TYPE_OPTIONS = [
  { value: "Personal Injury", label: "Personal Injury" },
  { value: "Medical Malpractice", label: "Medical Malpractice" },
  { value: "Auto Accident", label: "Auto Accident" },
  { value: "Slip and Fall", label: "Slip and Fall" },
  { value: "Product Liability", label: "Product Liability" },
  { value: "Small Claims", label: "Small Claims" },
  { value: "Contract", label: "Contract" },
  { value: "Employment", label: "Employment" },
  { value: "Landlord Tenant", label: "Landlord / Tenant" },
  { value: "Insurance Bad Faith", label: "Insurance Bad Faith" },
  { value: "Business Tort", label: "Business Tort" },
  { value: "Property Loss", label: "Property Loss" },
  { value: "Fraud", label: "Fraud" },
  { value: "Wrongful Death", label: "Wrongful Death" },
  { value: "Workers Compensation", label: "Workers' Compensation" },
];

export const JURISDICTION_OPTIONS = [
  { value: "California", label: "California" },
  { value: "New York", label: "New York" },
  { value: "Texas", label: "Texas" },
  { value: "Florida", label: "Florida" },
  { value: "Illinois", label: "Illinois" },
  { value: "Pennsylvania", label: "Pennsylvania" },
  { value: "Ohio", label: "Ohio" },
  { value: "Georgia", label: "Georgia" },
  { value: "Michigan", label: "Michigan" },
  { value: "New Jersey", label: "New Jersey" },
  { value: "Arizona", label: "Arizona" },
  { value: "Nevada", label: "Nevada" },
  { value: "Federal Courts", label: "Federal Courts" },
];

export const CLAIM_TYPE_OPTIONS = [
  { value: "Auto PI", label: "Auto PI" },
  { value: "Medical Malpractice", label: "Medical Malpractice" },
  { value: "Property Damage", label: "Property Damage" },
  { value: "Workers Compensation", label: "Workers' Compensation" },
  { value: "General Liability", label: "General Liability" },
  { value: "Professional Liability", label: "Professional Liability" },
  { value: "Premises Liability", label: "Premises Liability" },
  { value: "Product Liability", label: "Product Liability" },
];

export const INJURY_TYPE_OPTIONS = [
  { value: "Herniated Disc", label: "Herniated Disc" },
  { value: "TBI", label: "Traumatic Brain Injury (TBI)" },
  { value: "Spinal Cord", label: "Spinal Cord Injury" },
  { value: "Broken Bones", label: "Broken Bones / Fractures" },
  { value: "Soft Tissue", label: "Soft Tissue" },
  { value: "Burns", label: "Burns" },
  { value: "Whiplash", label: "Whiplash" },
  { value: "Internal Organ", label: "Internal Organ Damage" },
  { value: "Wrongful Death", label: "Wrongful Death" },
  { value: "Emotional Distress", label: "Emotional Distress" },
];

export default SmartSelect;
